import { DefaultApartmentInfo } from "./DefaultApartmentInfo";
import { RomanianApartmentInfo } from "./RomanianApartmentInfo";
export const DELIVERY_ADDRESS_EMPTY_EXTRA = {
    sector: "",
    houseOrBlock: "House",
    block: "",
    staircase: "",
    floor: "",
    aptNumber: "",
    interphone: "",
    additionalInfo: "",
};
export const ApartmentInfo = {
    empty(country) {
        return country === "RO"
            ? new RomanianApartmentInfo()
            : new DefaultApartmentInfo();
    },
};
